import { workerstationService } from "@workerstation/shared/effect/service";
import { Context, Effect, Schema } from "effect";
import type { RuntimeDependencyError } from "../errors/dependency.ts";
import type { DigestInvocationError } from "../errors/digest.ts";

export const Sha256Hex = /* @__PURE__ */ (() => Schema.String.check(
  Schema.isPattern(/^[a-f0-9]{64}$/)
).pipe(Schema.brand("sha256-hex")))();
export type Sha256Hex = typeof Sha256Hex.Type;

export class Digest extends workerstationService<Digest, {
  readonly sha256Utf8: (text: string) => Effect.Effect<Sha256Hex, RuntimeDependencyError>;
  readonly sha256Bytes: (bytes: ArrayBuffer) => Effect.Effect<Sha256Hex, RuntimeDependencyError>;
  /** Native view hashing retains the invocation's private failure boundary. */
  readonly sha256View: (bytes: Uint8Array<ArrayBuffer>) => Effect.Effect<string, DigestInvocationError>;
  /** Native await plus lazy arguments; retain the owner's hex lookup order. */
  readonly sha256Lazy: (bytes: () => Uint8Array<ArrayBuffer>, hexLookup?: "before-digest" | "after-digest") => Effect.Effect<string, DigestInvocationError>;
  /** Capability lookup precedes the supplied native argument evaluation. */
  readonly sha256Raw: (bytes: () => ArrayBuffer | Uint8Array<ArrayBuffer>) => Effect.Effect<ArrayBuffer, DigestInvocationError>;
}>()("Digest") {}
